export const EOTPOS = {
    PRODUCT: {
        STATUS: "eotpos_product_status",
        NAME: "eotpos_product_name",
        ROOT: "eotpos_product_root",
        THUMB: "eotpos_product_thumb",
        AMOUNT: "eotpos_product_amount",
        CONTENT: "eotpos_product_content",
    },
    PRODUCT_DETAILS: {
        ROOT: "eotpos_product-details_root",
        NAME: "eotpos_product-details_name",
        MATCHES_TITLE: "eotpos_product-details_matches-title",
        MATCHES_CONTAINER: "eotpos_product-details_matches-container",
        DROPDOWN: {
            MULTIPLE_MATCHES_ISSUE: "eotpos_product-details-dropdown_multiple-matches-issue",
        },
    },
    MODAL: {
        MAIN: {
            ROOT: "eotpos_main-modal_root",
            LOADING: "eotpos_main-modal_loading",
            CONTENT: "eotpos_main-modal_content",
            EXPORTED_ITEMS_MSG: "eotpos_main-modal_exported-items-msg",
            ORDER_NUMBER: "eotpos_main-modal_order-number",
        },
        ERROR: "eotpos_error-modal_root",
    },
    TABS: {
        SUMMARY_TAB: {
            NAME: "eotpos_tabs_summary-tab-name",
            CONTENT: "eotpos_tabs_summary-tab-content",
        },
        MATCHES_TAB: {
            NAME: "eotpos_tabs_matches-tab-name",
            CONTENT: "eotpos_tabs_matches-tab-content",
            WARNING_ICON: "eotpos_tabs_matches-tab-warning-icon",
        },
        NEW_ITEMS_TAB: {
            NAME: "eotpos_tabs_new-items-tab-name",
            CONTENT: "eotpos_tabs_new-items-tab-content",
            WARNING_ICON: "eotpos_tabs_new-items-tab-warning-icon",
        },
    },
    SUMMARY_TAB: {
        AMOUNT_OF_RELATIONS: "eotpos_summary-tab_amount-of-relations",
        AMOUNT_OF_NEW_ITEMS: "eotpos_summary-tab_amount-of-new-items",
        LINK_TO_MATCHES_TAB: "eotpos_summary-tab_link-to-matches-tab",
        LINK_TO_NEW_ITEMS_TAB: "eotpos_summary-tab_link-to-new-items-tab",
    },
    MATCHES_TAB: {
        NO_ITEMS: "eotpos_mathes-tab_no-items",
        WARNING_ICON: "eotpos__matches-tab-warning-icon",
    },
    NEW_ITEMS_TAB: {
        NO_ITEMS: "eotpos_new-items-tab_no-items-text",
        LOADING: "eotpos_new-items-tab_loading",
        WARNING_ICON: "eotpos_new-items-tab-warning-icon",
    },
};
